import React, { useState } from 'react'
import KeyFeatures from '../../molecules/KeyFeatures/KeyFeatures'
import IntroAnimation from '../../organisms/IntroAnimation/IntroAnimation'
import Message from '../../molecules/Message/Message'
import OutcomeImport from '../../molecules/OutcomeImport/OutcomeImport'
import Questions from '../../molecules/Questions/Questions'
import TatvacareHeroSection from '../../molecules/TatvacareHeroSection/TatvacareHeroSection'
import TatvacareProjectOverview from '../../molecules/TatvacareProjectOverview/TatvacareProjectOverview'
import TatvacareWhatyoubuild from '../../molecules/TatvacareWhatyoubuild/TatvacareWhatyoubuild'
import Testimonial from '../../molecules/Testimonial/Testimonial'
import FinalNote from '../../molecules/FinalNote/FinalNote'
import Footer from '../../organisms/Footer/Footer'
import pageIcon from '../../../assets/images/tatvacare/Vector.svg'

const iconPositions = [
  'right-[10%] top-[17.5%] md:right-[18%] md:top-[18%] lg:right-[18%] lg:top-[19%] xl:right-[18%] xl:top-[20%] 2xl:right-[20%] 2xl:top-[22%] h-3 w-3 md:h-4 md:w-4  xl:h-6 xl:w-6 ',
  'left-[15%] top-[26%] md:left-[30%] md:top-[23%] lg:left-[35%] lg:top-[25%] xl:left-[36%] xl:top-[26%] 2xl:left-[35%] 2xl:top-[28%] h-3 w-3 md:h-4 md:w-4  xl:h-6 xl:w-6 ',
  'right-[15%] top-[29%] md:right-[45%] md:top-[27%] lg:right-[47%] lg:top-[28%] xl:right-[47%] xl:top-[29%] 2xl:right-[45%] 2xl:top-[31%] h-3 w-3 md:h-4 md:w-4  xl:h-6 xl:w-6',
  'right-[15%] top-[36%] md:right-[20%] md:top-[33%] lg:right-[4%] lg:top-[34%] xl:right-[6%] xl:top-[35%] 2xl:right-[5%] 2xl:top-[37%] h-3 w-3 md:h-4 md:w-4 xl:h-6 xl:w-6 ',
  'left-[5%] top-[42.8%] md:left-[4%] md:top-[41%] lg:left-[4%] lg:top-[38%] xl:left-[4%] xl:top-[40%] 2xl:left-[5%] 2xl:top-[44%] h-3 w-3 md:h-4 md:w-4 xl:h-6 xl:w-6 ',
  'right-[5%] top-[49%] md:right-[7%] md:top-[49%] lg:right-[7%] lg:top-[48%] xl:right-[7%] xl:top-[51%] 2xl:right-[5%] 2xl:top-[58%] h-3 w-3 md:h-4 md:w-4 xl:h-6 xl:w-6 ',
  'left-[5%] top-[56%] md:left-[15%] md:top-[57%] lg:left-[15%] lg:top-[56%] xl:left-[23%] xl:top-[59%] 2xl:left-[30%] 2xl:top-[64%] h-3 w-3 md:h-4 md:w-4 xl:h-6 xl:w-6 ',
  'right-[1%] top-[59%] md:right-[1%] md:top-[60%] lg:right-[1%] lg:top-[60%] xl:right-[2%] xl:top-[63%] 2xl:right-[3%] 2xl:top-[68%] h-3 w-3 md:h-4 md:w-4 xl:h-6 xl:w-6 ',
]
const TatvaCarePage = () => {
  const [startAnimation, setStartAnimation] = useState(false)

  // 🔥 FORCE RE-MOUNT INTRO EVERY VISIT
  const [introKey] = useState(() => Date.now())
  return (
    <div
  className="relative min-h-screen w-full overflow-x-hidden text-white"
  style={{
    background:
      'linear-gradient(177.05deg, #4B4AD5 -7.59%, #A461D8 75.6%)',
  }}
>
  {/* Icons */}
  {iconPositions.map((position, index) => (
    <img
      key={index}
      src={pageIcon}
      alt=""
      className={`pointer-events-none absolute z-999 ${position}`}
    />
  ))}

  <div className="relative z-10">
  <IntroAnimation
        key={introKey}
        words={['TATVACARE']}
        wordColors={['#f8f8f8', '#ffffff']}
        backgroundGradient={{
          top: '#4B4AD5',
          bottom: '#A461D8',
        }}
        onHeroStart={() => setStartAnimation(true)}
      />
    <TatvacareHeroSection />
    <TatvacareProjectOverview />
    <TatvacareWhatyoubuild />
    <KeyFeatures />
    <OutcomeImport />
    <FinalNote />
    <Testimonial className="mx-auto mb-20 max-w-[90%]" showHeader themeColor="tatvacaretheme" />
      <div className="mb-10 px-4 md:px-8 2xl:mx-20 xl:px-12">
        <div className="grid w-full grid-cols-1 gap-5 xl:min-h-[620px] 2xl:min-h-[710px] lg:grid-cols-[1fr_1fr] xl:grid-cols-[1fr_2fr]">
          
          <Message themeColor="tatvacaretheme" />
          <Questions themeColor="tatvacaretheme" />
        </div>
      </div>
    <Footer />
  </div>
</div>
  )
}

export default TatvaCarePage
